export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70c4f82f0b52a4c6c1d273d7f8c1709da13d17c9fd&name=pushAdClickData!'